import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AppShell from "../components/AppShell";
import { getFinancialIndex } from "../data/financialContent";
import T from "../components/T";
import { ChevronLeft, ChevronRight, DollarSign } from "lucide-react";

export default function Financial() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const topics = getFinancialIndex(i18n.language);

  return (
    <AppShell>
      <div className="px-8 pt-16 pb-6" data-testid="page-financial">
        <button onClick={() => navigate(-1)} className="flex items-center gap-1 text-sm text-foreground/55 hover:text-brand mb-2">
          <ChevronLeft className="w-4 h-4" /> {t("common.back")}
        </button>
        <p className="font-script text-2xl text-brand">{t("financial.kicker")}</p>
        <h1 className="font-serif text-4xl leading-tight">
          <T i18nKey="financial.h" />
        </h1>
        <p className="mt-3 text-foreground/70 leading-relaxed">{t("financial.intro")}</p>
        <p className="mt-2 text-sm text-foreground/55 italic leading-relaxed">{t("financial.toolkit_hint")}</p>
      </div>

      <div className="px-8 space-y-3 pb-10">
        {topics.map((topic) => (
          <button
            key={topic.slug}
            data-testid={`fin-topic-${topic.slug}`}
            onClick={() => navigate(`/financial/${topic.slug}`)}
            className="w-full text-left rounded-3xl bg-card border border-border p-5 hover:border-brand/50 transition-all"
          >
            <div className="flex items-start gap-3">
              <span className="w-9 h-9 grid place-items-center rounded-full bg-brand/10 text-brand shrink-0">
                <DollarSign className="w-4 h-4" />
              </span>
              <div className="flex-1 min-w-0">
                <div className="font-serif text-lg leading-snug">{topic.title}</div>
                <p className="text-sm text-foreground/70 mt-1 leading-relaxed">{topic.short}</p>
              </div>
              <ChevronRight className="w-4 h-4 text-foreground/40 shrink-0 mt-2" />
            </div>
          </button>
        ))}
      </div>
    </AppShell>
  );
}
